module.exports = __webpack_public_path__ + "fonts/Satoshi-Regular.e916617.woff2";